//@ts-nocheck
//watchlist name calling api function
import { getConfig } from "../config/config";
import { decryptEnv } from "../helpers";
const { APP_BASE_API_URL, APP_OCP_APIM_KEY, APP_HEAD_KEY, APP_BASE_SWARAJ_API_URL, APP_USER_ID, APP_PASSWORD } = getConfig();
export const getDefault = async () => {
    return new Promise(async (resolve, reject) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Ocp-Apim-Subscription-Key", decryptEnv(APP_OCP_APIM_KEY));
            var raw = JSON.stringify({
                head: {
                    appName: "5PTRADE",
                    appSource: "09",
                    appVer: "1.0",
                    osName: "Web",
                    key: decryptEnv(APP_HEAD_KEY),
                    requestCode: "5PDecGMWRVMW3",
                },
                body: {
                    ClientCode: `${localStorage.getItem("ClientCode")}`,
                },
            });
            var requestOptions = {
                method: "POST",
                credentials: "include",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };
            const response = await fetch(`${APP_BASE_API_URL}tradeapi/GetMWatchListRVMW1`, requestOptions);
            const result = await response.json();
            let defaultList = result.body.MWName;
            const mwatchNames = defaultList.filter((item) => (item.CanEditOrDelete === true || (item === null || item === void 0 ? void 0 : item.MwatchName) == "MY STOCKS" || (item === null || item === void 0 ? void 0 : item.MwatchName) == "NIFTY50") && (item.ScripCount !== 0));
            //  .map(item => item.MwatchName);
            resolve(mwatchNames);
        }
        catch (error) {
            console.log("error", error);
            reject(error);
        }
    });
};
//watchlist symbol calling function
export const getDefaultSymbolNames = async (MORE) => {
    return new Promise(async (resolve, reject) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Ocp-Apim-Subscription-Key", decryptEnv(APP_OCP_APIM_KEY));
            var raw = JSON.stringify({
                Clientcode: `${localStorage.getItem("ClientCode")}`,
                MWName: MORE,
                ClientLoginType: "1",
            });
            var requestOptions = {
                method: "POST",
                credentials: "include",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };
            const response = await fetch(`${APP_BASE_API_URL}tradeapi/GetNewMarketWatch`, requestOptions);
            const result = await response.json();
            let defaultListsymbol = [];
            let socketToBeConnected = [];
            result.Data.map(async (item, index, array) => {
                let formattedEx;
                switch (item.Exch) {
                    case "N":
                    case "NSE":
                    case "nse":
                        formattedEx = "NSE";
                        break;
                    case "B":
                    case "BSE":
                    case "bse":
                        formattedEx = "BSE";
                        break;
                    default:
                        formattedEx = "MCX";
                        break;
                }
                let fullName;
                if (item.ExchType == "U" || item.ExchType == "D") {
                    fullName = `${formattedEx}:${item.Name.trim() + " " + item.FullName}/${item.ScripCode}-${item.ExchType}`;
                }
                else {
                    fullName = `${formattedEx}:${item.Name.trim()}/${item.ScripCode}-${item.ExchType}`;
                }
                defaultListsymbol.push(fullName);
                if (index == array.length - 1) {
                    resolve(defaultListsymbol);
                }
            });
        }
        catch (error) {
            console.log("error", error);
            reject(error);
        }
    });
};
// async function RealTimeHoldings() {
//   return new Promise(async (resolve, reject) => {
//     try {
//       var myHeaders = new Headers();
//       myHeaders.append("Content-Type", "application/json");
//       myHeaders.append("Ocp-Apim-Subscription-Key", APP_OCP_APIM_KEY);
//       var raw = JSON.stringify({
//         head: {
//           appName: "5PTRADE",
//           appSource: "21",
//           appVer: "1.0",
//           osName: "Web",
//           key: APP_HEAD_KEY,
//           requestCode: "5PGRTHV2",
//         },
//         body: {
//           ClientCode: `${localStorage.getItem("ClientCode")}`,
//         },
//       });
//       var requestOptions = {
//         method: "POST",
//         credentials: "include",
//         headers: myHeaders,
//         body: raw,
//         redirect: "follow",
//       };
//       const response = await fetch(
//         `${APP_BASE_API_URL}tradeapi/GetRealTimeHolding`,
//         requestOptions
//       );
//       const result = await response.json();
//       let defaultList = result.body.RealTimeHoldingData;
//      console.log(defaultList);
//        const defaultListsymbol = [];
//       const socketToBeConnected = [];
//       // result.body.RealTimeHoldingData.map(async (item, index, array) => {
//       //   let formattedEx;
//       //   switch (item.Exch) {
//       //     case "N":
//       //     case "NSE":
//       //     case "nse":
//       //       formattedEx = "NSE";
//       //       break;
//       //     case "B":
//       //     case "BSE":
//       //     case "bse":
//       //       formattedEx = "BSE";
//       //       break;
//       //     default:
//       //       formattedEx = "MCX";
//       //       break;
//       //   }
//       //   let fullName;
//       //   if (item.ExchType == "U" || item.ExchType == "D") {
//       //     fullName = `${formattedEx}:${
//       //       item.Name.trim() + " " + item.FullName
//       //     }/${item.ScripCode}-${item.ExchType}`;
//       //   } else {
//       //     fullName = `${formattedEx}:${item.Name.trim()}/${item.ScripCode}-${
//       //       item.ExchType
//       //     }`;
//       //   }
//       //   // let fullName = `${item.Exch}:${(item.Name).trim()}/${item.ScripCode}/${(item.ShortName).trim()}/${item.ExchType}/searchTrue`;
//       //   // let fullName = `${item.Exch}:${(item.Name).trim()}/${item.ScripCode}-${item.ExchType}`;
//       //   let instrument =
//       //     `${item.Exch}` + "" + `${item.ExchType}` + "" + `${item.ScripCode}`;
//       //   socketToBeConnected.push(instrument);
//       //   defaultListsymbol.push(fullName);
//       //   if (index == array.length - 1) {
//       //     await watchlistSocketConnection(socketToBeConnected);
//       //     resolve(defaultListsymbol);
//       //   }
//       // });
//       // const mwatchNames = defaultList.filter(
//       //   (item) => item.IsSelect !== "N" && item.ScripCount !== 0
//       // );
//       //  .map(item => item.MwatchName);
//       resolve(defaultList);
//     } catch (error) {
//       console.log("error", error);
//       reject(error);
//     }
//   });
// }
// RealTimeHoldings();
